import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import { useIsMobile } from '#src/app/shared/hooks/userAgent';

/**
 * Whether SharingGoalFlow is actually rendering right now -- the single source of truth every
 * consumer (PageBody's render branch, its share_feed_view tracking effect, useRedirect's post-share
 * destination) must read, rather than re-deriving locally.
 */
export function useShouldShowSharingGoalFlow(): boolean {
	const {
		data: {
			skip,
			featureConfigs: { isSuperRecruiterFlowEnabled, isShareSlideUpEnabled },
		},
	} = usePsfSharePageData();
	const isMobile = useIsMobile();

	return !skip && isSuperRecruiterFlowEnabled && isShareSlideUpEnabled && isMobile;
}
